import {Card, Flex, Select, Typography} from "antd";
import ClimateChangeContent from "./ClimateChangeContent";
import {capitalize} from "lodash";
import {useTranslation} from "react-i18next";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import {useState} from "react";
import {useAssetDetails} from "../../../../context/assetDetails/AssetDetails";
import ClimateChangeReportDownload from "./ClimateChangeReportDownload";
import ClimateHazardsRadarContent from "./radar/ClimateHazardsRadarContent";

// TODO: view switch for the mock-up, keep only the approved view
type ClimateChangeView = 'current' | 'radarByPeriod' | 'radarAllPeriods'

export default function ClimateChangeCard() {

  const {t} = useTranslation()
  const [, {asset}] = useAssetDetails();
  const {xs} = useBreakpoint()
  const [view, setView] = useState<ClimateChangeView>('current')

  const viewSelector = <Flex gap={'small'} align={'center'}>
    <Typography.Text strong>{capitalize(t('climateChange.view'))}:</Typography.Text>
    <Select
      value={view}
      onChange={setView}
      style={{minWidth: 260}}
      options={[
        {value: 'current', label: capitalize(t('climateChange.views.current'))},
        {value: 'radarByPeriod', label: capitalize(t('climateChange.views.radarByPeriod'))},
        {value: 'radarAllPeriods', label: capitalize(t('climateChange.views.radarAllPeriods'))},
      ]}
    />
  </Flex>

  return <Card
    title={capitalize(t('assets.climateChange'))}
    bodyStyle={{
      ...xs && {padding: 0}
    }}
    extra={
      <ClimateChangeReportDownload
      assetUuid={asset.uuid}
      buttonProps={{
        disabled: asset.position === null
      }}
    />}
  >
    {view === 'current' ?
      <Flex vertical gap={'middle'}>
        {viewSelector}
        <ClimateChangeContent assetUuid={asset.uuid} missingCoordinates={asset.position === null} showImpactedHazards/>
      </Flex> :
      <ClimateHazardsRadarContent
        key={view}
        assetUuid={asset.uuid}
        mode={view === 'radarByPeriod' ? 'period' : 'allPeriods'}
        missingCoordinates={asset.position === null}
        viewSelector={viewSelector}
      />
    }
  </Card>
}
